import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "style"],
  _excluded2 = ["buttons"],
  _excluded3 = ["focus", "aria", "touchAction"],
  _excluded4 = ["toolbar", "open", "close", "className"];
import { LightboxRoot, cssVar, clsx, cssClass, createModule } from '../../index.js';
import * as React from 'react';
import { ACTION_CLOSE, MODULE_NO_SCROLL, MODULE_PORTAL, PLUGIN_INLINE } from '../../types.js';
function InlineContainer(_ref) {
  let {
      inline: {
        className,
        style
      } = {},
      styles,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref.inline, _excluded);
  return /*#__PURE__*/React.createElement(LightboxRoot, Object.assign({
    className: clsx(cssClass("relative"), className),
    style: Object.assign({
      [cssVar("controller_overscroll_behavior")]: "contain auto"
    }, styles.root, style)
  }, rest), children);
}
function Inline(_ref2) {
  let {
    augment,
    replace,
    remove
  } = _ref2;
  augment(_ref3 => {
    let {
        toolbar: {
          buttons
        },
        className
      } = _ref3,
      restToolbar = _objectWithoutPropertiesLoose(_ref3.toolbar, _excluded2),
      restController = _objectWithoutPropertiesLoose(_ref3.controller, _excluded3),
      restProps = _objectWithoutPropertiesLoose(_ref3, _excluded4);
    return Object.assign({
      open: true,
      close: () => {},
      toolbar: Object.assign({
        buttons: buttons.filter(button => button !== ACTION_CLOSE)
      }, restToolbar),
      inline: {
        style: {
          width: "100%",
          height: "100%"
        },
        className
      },
      controller: Object.assign({
        focus: false,
        aria: true,
        touchAction: "pan-y"
      }, restController),
      className
    }, restProps);
  });
  remove(MODULE_NO_SCROLL);
  replace(MODULE_PORTAL, createModule(PLUGIN_INLINE, InlineContainer));
}
export { Inline as default };